<template>
    <div class="o-qr-reader qr-reader">
        <QrcodeStream
            @init="onInit"
            @detect="onDetect"
        />
        <div 
            v-if="errorMessage"
            class="qr-reader-manual"
        >
            <div class="qr-reader-manual__container">
                <span class="qr-reader__controls-layer-error">
                    {{ errorMessage }}
                </span>
                <ValidationProvider
                    v-slot="{ errors }"
                    class="qr-reader-manual__wrapper"
                    name="QR Code ID"
                    rules="digits:8"
                    tag="div"
                >
                    <span>
                        Enter QR id:
                    </span>
                    <AInput
                        v-model="manualInput"
                        clearable
                        inputType="number"
                    />
                    <span class="qr-reader-manual__error">
                        {{ errors[0] }}
                    </span>
                    <AButton
                        :disabled="errors[0] || !manualInput.length"
                        text="Submit"
                        @onClick="handleClick"
                    />
                </ValidationProvider>
            </div>
            <div class="qr-reader__controls-layer-footer">
                <AMBackButton
                    theme="back"
                    :text="$t('ui.back')"
                    @onClick="handleBack"
                />
            </div>
        </div>
        <div 
            v-else
            class="qr-reader__controls-layer"
        >
            <div class="qr-reader__controls-layer-header">
                <AMCloseButton
                    class="qr-reader__controls-layer-close-button"
                    @onClick="handleBack"
                />
            </div>
            <div class="qr-reader__controls-layer-container">
                <div class="qr-reader__controls-layer-inner-container">
                    <div class="qr-reader__controls-layer-wrapper">
                        <span class="qr-reader__controls-layer-text">
                            <strong>Scan QR</strong> code to <br> set your
                            <span class="qr-reader__controls-layer-empty-space" />
                            location
                        </span>
                        <span class="qr-reader__controls-layer-text-icon">
                            <span class="qr-reader__controls-layer-text-icon-inner">
                                DU <br> ÄR <br> HÄR
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="qr-reader__controls-layer-footer">
                <AMBackButton
                    theme="back"
                    :text="$t('ui.back')"
                    @onClick="handleBack"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AInput from '../../atoms/a-input/a-input';
import AButton from '../../atoms/a-button/a-button';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import AMCloseButton from '../../atoms/a-m-items-close-button/a-m-items-close-button'

import {
    NOTIFY_ERROR,
    GUIDE_NEW_POINT
} from '../../../utils/constants/bus-events-constants';
    
export default {
    name: 'OQrReader',
    components: {
        AInput,
        AButton,
        QrcodeStream: () => import('vue-qrcode-reader').then((vueQrcodeReader) => vueQrcodeReader.QrcodeStream),
        AMBackButton,
        AMCloseButton
    },
    data() {
        return {
            errorMessage: null,
            item: null,
            manualInput: ''
        }
    },
    computed: {
        ...mapGetters([
            'getDenormalisedObjectById'
        ])
    },
    methods: {
        handleBack() {
            this.$emit('onClickBack', true);
        },
        async onInit(promise) {
            try {
                await promise;
            } catch(error) {
                switch (error.name) {
                case 'NotAllowedError':
                    this.errorMessage = this.$t('qr-scan-error--access-permission');
                    break;
                case 'NotFoundError':
                    this.errorMessage = this.$t('qr-scan-error--no-camera');
                    break;
                case 'NotSupportedError':
                    this.errorMessage = this.$t('qr-scan-error--not-supported');
                    break;
                case 'NotReadableError':
                    this.errorMessage = this.$t('qr-scan-error--not-readable');
                    break;
                case 'OverconstrainedError':
                    this.errorMessage = this.$t('qr-scan-error--overconstrained');
                    break;
                case 'StreamApiNotSupportedError':
                    this.errorMessage = this.$t('qr-scan-error--stream-api-not-supported');
                    break;  
                default:
                    break
                }
            }
        },
        async onDetect(promise) {
            try {
                const { content } = await promise;
                const qrId = Number(content.split('/').find(el => el.includes('qr')).split('-')[1]);
                const qrObj = this.getDenormalisedObjectById(qrId) || '';

                if (qrObj) {
                    this.setNewPoint(qrObj.unit.id
                        // {
                        //     units: true,
                        //     id: qrObj.id
                        // }
                    );
                    console.log('UNIT', qrObj);
                } else {
                    console.log('Incorrect qr code ');
                }
            } catch(error) {
                this.$bus.$emit(NOTIFY_ERROR, error);
            }
        },
        handleClick() {
            this.setNewPoint(this.manualInput);
        },
        setNewPoint(data) {
            this.$bus.$emit(GUIDE_NEW_POINT, data);
        }
    }
}
</script>

<style lang="scss">
@import "o-qr-reader";
</style>